import React from 'react';
import ArrowUp from '../../../icons/ArrowUp';
import ArrowDown from '../../../icons/ArrowDown';

import * as S from './listing-section.styles';

const SortBySection = ({
  sortByRef,
  active,
  showSortby,
  showSortAsc,
  setSortOrder,
  applySortSettings,
  sortByHandle,
  handleSortBy
}) => {
  return (
    <S.SortBySection>
      <span className="f500 font10">SHOWING FARES FOR</span>
      <div className="posRel">
        <span>
          <span className="f500 font10 greyCnt">SORT BY : </span>
          <span
            ref={sortByRef}
            onClick={handleSortBy}
            className="blueCnt f500 font10 posRel marginR5"
          >
            {showSortby}
          </span>
          <span
            onClick={() => {
              setSortOrder(!showSortAsc);
              applySortSettings(showSortby.toLowerCase(), !showSortAsc);
            }}
          >
            {!showSortAsc ? (
              <ArrowUp width="1rem" height="1rem" />
            ) : (
              <ArrowDown width="1rem" height="1rem" />
            )}
          </span>
        </span>
        {active && (
          <>
            <ul className="sortByoptions">
              <li
                onClick={() => {
                  sortByHandle('CHEAPEST');
                  applySortSettings('cheapest', showSortAsc);
                }}
                className="active"
              >
                CHEAPEST
              </li>
              <li
                onClick={() => {
                  sortByHandle('SHORTEST');
                  applySortSettings('shortest', showSortAsc);
                }}
              >
                SHORTEST
              </li>
            </ul>
          </>
        )}
      </div>
    </S.SortBySection>
  );
};
export default SortBySection;
